// src/features/master-data/components/MasterDataTable.js
import React from 'react';
import { Edit, Trash2, Eye, MoreVertical, Copy, Power, History } from 'lucide-react';
import Table from '../../../shared/components/Table';
import Badge from '../../../shared/components/Badge';
import { tableColumns } from '../config/masterDataConfig';

const MasterDataTable = ({
  type,
  data,
  loading,
  sortColumn,
  sortDirection,
  onSort,
  onEdit,
  onDelete,
  onView,
  onToggleStatus,
  onDuplicate,
  onViewHistory,
  selectedRows,
  onSelectRow,
  onSelectAll,
  //actions = ['edit', 'delete', 'toggle', 'view', 'duplicate', 'history'],
  actions = ['edit', 'toggle'],
}) => {
  const columns = tableColumns[type] || [];

  const defaultActions = (row) => (
    <div className="flex items-center justify-end space-x-2">
      {actions.includes('view') && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onView(row);
          }}
          className="p-1 text-gray-500 hover:text-blue-600 transition-colors"
          title="View Details"
        >
          <Eye className="h-4 w-4" />
        </button>
      )}
      
      {actions.includes('edit') && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onEdit(row);
          }}
          className="p-1 text-gray-500 hover:text-green-600 transition-colors"
          title="Edit"
        >
          <Edit className="h-4 w-4" />
        </button>
      )}
      
      {actions.includes('duplicate') && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onDuplicate(row);
          }}
          className="p-1 text-gray-500 hover:text-purple-600 transition-colors"
          title="Duplicate"
        >
          <Copy className="h-4 w-4" />
        </button>
      )}
      
      {actions.includes('toggle') && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onToggleStatus(row);
          }}
          className={`p-1 transition-colors ${
            row.is_active 
              ? 'text-green-600 hover:text-green-700' 
              : 'text-gray-400 hover:text-gray-600'
          }`}
          title={row.is_active ? 'Deactivate' : 'Activate'}
        >
          <Power className="h-4 w-4" />
        </button>
      )}
      
      {actions.includes('history') && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onViewHistory(row);
          }}
          className="p-1 text-gray-500 hover:text-orange-600 transition-colors"
          title="View History"
        >
          <History className="h-4 w-4" />
        </button>
      )}
      
      {actions.includes('delete') && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onDelete(row);
          }}
          className="p-1 text-gray-500 hover:text-red-600 transition-colors"
          title="Delete"
        >
          <Trash2 className="h-4 w-4" />
        </button>
      )}
      
      <button
        onClick={(e) => {
          e.stopPropagation();
          // Show more options menu
        }}
        className="p-1 text-gray-500 hover:text-gray-700 transition-colors"
      >
        <MoreVertical className="h-4 w-4" />
      </button>
    </div>
  );

  return (
    <Table
      columns={columns}
      data={data}
      loading={loading}
      sortColumn={sortColumn}
      sortDirection={sortDirection}
      onSort={onSort}
      onRowClick={onView}
      actions={defaultActions}
      selectedRows={selectedRows}
      onSelectRow={onSelectRow}
      onSelectAll={onSelectAll}
    />
  );
};

export default MasterDataTable;